import { render, staticRenderFns } from "./WorkShift.vue?vue&type=template&id=3c018fee&scoped=true"
import script from "./WorkShift.vue?vue&type=script&lang=js"
export * from "./WorkShift.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c018fee",
  null
  
)

export default component.exports